<template>
  <div class="password-reset">
    <PasswordReset />
  </div>
</template>

<script>
import PasswordReset from "@/components/PasswordReset.vue";

export default {
  name: "password-reset-view",
  components: {
    PasswordReset,
  },
};
</script>
